
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-successful",
      function () {
        return require("private-next-pages/order-successful/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-successful"])
      });
    }
  